import { useEffect } from 'react';
import { usePagination, useQueryParams } from '@/hooks';
import { ROUTES_TABLE_DEFAULT_PAGE_SIZE } from '../constants/routesTable.constants';

const useRoutesPagination = () => {
  const { setQueryParams, getQueryParam } = useQueryParams();
  const rawPageSize = Number(getQueryParam('pageSize'));
  const initialPageSize =
    Number.isFinite(rawPageSize) && rawPageSize > 0
      ? rawPageSize
      : ROUTES_TABLE_DEFAULT_PAGE_SIZE;

  const { currentPage, pageSize, handlePageChange, handlePageSizeChange } =
    usePagination({
      initialPage: Number(getQueryParam('page')) || 1,
      initialPageSize,
    });

  useEffect(() => {
    setQueryParams({
      page: String(currentPage),
      pageSize: String(pageSize),
    });
  }, [currentPage, pageSize, setQueryParams]);

  return { currentPage, pageSize, handlePageChange, handlePageSizeChange };
};

export default useRoutesPagination;
